import { ResultOf } from "gql.tada";
import { GetCaseStudyHomepageById } from "@queries/archetypes/GetCaseStudyHomepageById";
import { CaseStudyCardSection } from "@components/entries/CaseStudyCardSection";

type CaseStudyShowcaseItem = NonNullable<
  ResultOf<typeof GetCaseStudyHomepageById>["caseStudyHomepage"]
>["caseStudyShowcase"];

export const CaseStudyShowcase = ({ item }: { item: CaseStudyShowcaseItem }) => {
  if (!item) return null;
  switch (item.__typename) {
    case "CaseStudyCardSection":
      return <CaseStudyCardSection entry={{ caseStudyCardSection: item }} />;
    // TODO: Support for carousels
    default:
      return null;
  }
};
